import PropTypes from 'prop-types'
import { Component } from 'react'
import { Bar, BarChart, Cell, LabelList, XAxis, YAxis } from 'recharts'

class VerticalBarChart extends Component<any, any> {
  static displayName = 'VerticalBarChart'

  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    data: PropTypes.array.isRequired,
    nameKey: PropTypes.string,
    dataKey: PropTypes.string
  }

  static defaultProps = {
    animate: false,
    label: true,
    tooltip: false,
    colors: ['#27bfad', '#fcd142', '#2bb3e4'],
    dataKey: 'value',
    nameKey: 'name',
    height: 350,
    width: 420,
    className: 'horizontal-bar-chart'
  }

  maxChartValue = (dataMax: any) => {
    if (dataMax < 10) return 10
    return Math.round(dataMax * 1.8)
  }

  render() {
    const { className, width, height, data, animate, colors, dataKey, nameKey } = this.props
    return (
      <BarChart
        className={className}
        height={height}
        width={width}
        data={data}
        barCategoryGap={1}
        style={{ paddingTop: '20px' }}
      >
        <XAxis type="category" dataKey={nameKey} tickLine={false} axisLine={false} tick={{ fontSize: '0.8rem' }} />
        <YAxis
          type="number"
          dataKey={dataKey}
          tickLine={false}
          domain={[0, (dataMax: any) => this.maxChartValue(dataMax)]}
          hide
        />
        <Bar dataKey={dataKey} isAnimationActive={animate}>
          {/* @ts-expect-error */}
          <LabelList dataKey={dataKey} position="top" style={{ fill: 'black' }} />
          {data.map((entry: any, index: any) => (
            <Cell key={entry} fill={colors[index % colors.length]} />
          ))}
        </Bar>
      </BarChart>
    )
  }
}

export default VerticalBarChart
